// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65b12813","455":"3b3b5f1a","644":"96355e1c"}[chunkId] + ".chunk.js";
};